// src/components/BCP/NavigationButtons.tsx
import React from 'react';
import { Step } from '../../types/bcpForm';

interface NavigationButtonsProps {
  steps: Step[];
  currentStep: number;
  totalSteps: number;
  onPrevStep: () => void;
  onNextStep: () => void;
  onSubmit: () => void;
  submitting: boolean;
  canProceed: boolean;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  steps,
  currentStep,
  totalSteps,
  onPrevStep,
  onNextStep,
  onSubmit,
  submitting,
  canProceed,
}) => {
  return (
    <div className="flex justify-between items-center px-8 py-6 bg-gray-50">
      <button
        type="button"
        onClick={onPrevStep}
        disabled={currentStep === 1}
        className="px-6 py-2 text-gray-700 rounded-xl border border-gray-300 transition-all duration-200 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Previous
      </button>

      <div className="flex space-x-2">
        {steps.map((_, index) => (
          <div
            key={index}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index + 1 <= currentStep ? 'bg-blue-600' : 'bg-gray-300'
            }`}
          />
        ))}
      </div>

      {currentStep < totalSteps ? (
        <button
          type="button"
          onClick={onNextStep}
          disabled={!canProceed}
          className="px-6 py-2 font-medium text-white bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl shadow-lg transition-all duration-200 hover:from-blue-700 hover:to-indigo-700 hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Next Step
        </button>
      ) : (
        <button
          type="button"
          onClick={onSubmit}
          disabled={submitting || !canProceed}
          className="px-8 py-3 font-semibold text-white bg-blue-600 rounded-xl transition-all duration-200 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {submitting ? (
            <div className="flex items-center">
              <svg className="mr-3 -ml-1 w-5 h-5 text-white animate-spin" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Generating...
            </div>
          ) : (
            'Generate BCP'
          )}
        </button>
      )}
    </div>
  );
};

export default NavigationButtons;